import { useMutation } from '@tanstack/react-query';
import { POST, POST_INSERT_QR_CODE } from '../../../services';
import { openAlert } from '../../../components/alert/useAlert';

const buildInsertQrPayload = (values) => ({
  categoryId: values.categoryId,
  recipientEmail: values.recipientEmail,
  urlLink: values.urlLink,
  serialNumberAmount: parseInt(values.serialNumberAmount, 10) || 0,
  remark: values.remark,
  startDate: values.startDate,
  expireDate: values.expireDate,
});

export const useInsertQr = () => {
  return useMutation({
    mutationFn: async (values) => {
      const payload = buildInsertQrPayload(values);
      const response = await POST(POST_INSERT_QR_CODE(), payload);

      return response.result;
    },
    onSuccess: () => {
      openAlert({
        model: 'message',
        type: 'success',
        message: 'บันทึกข้อมูล QR สำเร็จ',
      });
    },
    onError: (error) => {
      openAlert({
        model: 'message',
        type: 'error',
        message: error?.message || 'แก้ไขข้อมูลไม่สำเร็จ',
      });
    },
  });
};
